<header class="bg-primary-500">
  <div class="flex items-center justify-between px-4 py-2 lg:px-5 xl:px-15 xxl:px-20">
    <a class="hidden text-lg font-semibold text-white hover:opacity-75 lg:inline" routerLink="/">nDziekanat</a>
    <button
      type="button"
      ndt-icon-button
      class="text-white hover:opacity-75 lg:hidden"
      aria-label="Pokaż menu"
      i18n-aria-label
      (click)="showMobileMenu.emit()"
    >
      <app-icon name="bars"></app-icon>
    </button>
    <div class="inline-flex flex-wrap items-center gap-2.5 sm:gap-4">
      <app-modules-menu></app-modules-menu>

      <button
        ndt-icon-button
        type="button"
        [disabled]="currentFontSize === 0"
        class="text-white enabled:hover:opacity-75 disabled:text-muted"
        aria-label="Pomniejsz czcionkę"
        i18n-aria-label
        (click)="zoomOut()"
        >a-</button
      >
      <button
        ndt-icon-button
        type="button"
        [disabled]="currentFontSize === 4"
        class="text-white enabled:hover:opacity-75 disabled:text-muted"
        aria-label="Powiększ czcionkę"
        i18n-aria-label
        (click)="zoomIn()"
        >A+</button
      >
      <button
        *ngIf="isWindowsHighContrastDisabled"
        ndt-icon-button
        type="button"
        class="text-white hover:opacity-75"
        aria-label="Przełącz wysoki kontrast"
        i18n-aria-label
        (click)="toggleContrast()"
      >
        <app-icon name="contrast"></app-icon>
      </button>

      <div ngbDropdown #userMenu="ngbDropdown" container="body" display="dynamic">
        <button
          type="button"
          class="relative inline-flex items-center gap-1 p-0 text-white after:hidden hover:text-opacity-75"
          aria-controls="user-menu"
          ngbDropdownToggle
        >
          <app-icon name="user-circle"></app-icon>
          <span *ngIf="authService.authTokenData$ | async as user">{{ user?.given_name }} {{ user?.family_name }}</span>
          <span
            *ngIf="!userMenu.isOpen() && wiadomosciFacade.unreadMessagesCount | async as unread"
            class="badge badge-pill ms-auto bg-primary-200 text-body"
          >
            {{ unread }}
          </span>
          <app-icon
            class="transition-transform"
            [ngClass]="{ 'rotate-180': userMenu.isOpen() }"
            name="chevron-down"
          ></app-icon>
        </button>

        <ul ngbDropdownMenu id="user-menu" class="dropdown-menu" role="menu">
          <li role="menuitem">
            <a class="dropdown-item flex items-center gap-1" routerLink="/ustawienia">
              <app-icon name="user"></app-icon><ng-container i18n>Mój profil</ng-container>
            </a>
          </li>
          <li role="menuitem">
            <a class="dropdown-item flex items-center gap-1" routerLink="/wiadomosci">
              <app-icon name="inbox"></app-icon><ng-container i18n>Wiadomości</ng-container>
              <span
                *ngIf="wiadomosciFacade.unreadMessagesCount | async as unread"
                class="badge badge-pill ml-auto bg-info"
              >
                {{ unread }}
              </span>
            </a>
          </li>

          <li role="menuitem">
            <a
              class="dropdown-item flex items-center gap-1"
              routerLink="ogloszenia/administrator"
              *ngIf="'Komunikacja.PlatformaAdministracyjna.Ogloszenia.Lista' | hasPermission"
            >
              <app-icon name="bullhorn"></app-icon><ng-container i18n>Ogłoszenia</ng-container>
            </a>
            <a
              class="dropdown-item flex items-center gap-1"
              routerLink="ogloszenia/wykladowca"
              *ngIf="'Komunikacja.PlatformaPracownikaNaukowego.Ogloszenia.Lista' | hasPermission"
            >
              <app-icon name="bullhorn"></app-icon><ng-container i18n>Ogłoszenia</ng-container>
            </a>
            <a
              class="dropdown-item flex items-center gap-1"
              routerLink="ogloszenia/student"
              *ngIf="'Komunikacja.PlatformaStudenta.Ogloszenia.Lista' | hasPermission"
            >
              <app-icon name="bullhorn"></app-icon><ng-container i18n>Ogłoszenia</ng-container>
            </a>
          </li>

          <li role="menuitem" (click)="authService.logOut()">
            <a class="dropdown-item flex items-center gap-1 cursor-pointer">
              <app-icon name="sign-out"></app-icon><ng-container i18n>Wyloguj</ng-container>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
